import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const AXE_FLAGS = ['L', 'LS', 'OR', 'S'] as const

export type AxeFlag = (typeof AXE_FLAGS)[number]

export const AXE_FLAG_OPTIONS = sortAlphabeticallyByKey(
  AXE_FLAGS.map((a) => ({ label: a, value: a })),
  'label',
)
